export { default } from './Employees';


// WEBPACK FOOTER //
// ./src/partials/modules/Employees/index.js